<template>
  <div class="vx-card p-6">
    <div class="flex flex-wrap items-center">
      <div class="vx-row flex">
        <div class="w-1/5 ml-2 mt-1">
          <div style="cursor: pointer; width:100px;" class="px-4 py-1 flex items-center">
            <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
            <JsonExcel :data="calls" class>İndir</JsonExcel>
          </div>
        </div>
      </div>

      <vs-popup title="Arama Detayları" :active.sync="popupActivo.show">
        <div class="vx-row flex">
          <table>
            <tr v-for="(tr, index) in popupActivo.displayedKeys" :key="index">
              <td>{{popupActivo.title[tr]}}</td>
              <td>{{popupActivo.detail[tr]}}</td>
            </tr>
          </table>
        </div>
      </vs-popup>

      <vs-table
        search
        noDataText="Arama Bulunamadı!"
        :data="calls"
        :pagination="true"
        :maxItems="10"
        class="w-full"
      >
        <template slot="thead">
          <vs-th style="width: 30px;">Tarih</vs-th>
          <vs-th style="width: 30px;">Numara</vs-th>
          <vs-th style="width: 30px;">Cevaplayan</vs-th>
          <vs-th style="width: 30px;">Durum</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, i) in data" :key="i">
            <vs-td>
              <a
                href="#"
                title="Detay görüntüle"
                @click="openPopup(tr)"
              >{{ tr.start_stamp.substr(0,16) }}</a>
            </vs-td>
            <vs-td>{{ tr.caller_id_number==tr.caller_id_name?tr.caller_id_number:tr.caller_id_name }}</vs-td>
            <vs-td>{{ (tr.destination_name||tr.destination_number) }}</vs-td>
            <vs-td>{{ tr.result }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
import { repository } from "@/_services/repository.js";
import JsonExcel from "vue-json-excel";
export default {
  components: {
    JsonExcel
  },

  data() {
    return {
      calls: [],
      popupActivo: {
        show: false,
        detail: {},
        displayedKeys: [
          "start_stamp",
          "direction",
          "caller_id_number",
          "caller_id_name",
          "destination_number",
          "destination_name",
          "duration",
          "talk_duration",
          "queue",
          "result",
          "missed",
          "sip_hangup_disposition",
          "answer_stamp",
          "end_stamp"
        ],
        title: {
          start_stamp: "Arama tarihi",
          direction: "Arama Yönü",
          caller_id_number: "Arayan no",
          caller_id_name: "Arayan",
          destination_number: "Cevaplayan No",
          destination_name: "Cevaplayan",
          duration: "Toplam Süre",
          talk_duration: "Görüşme süresi",
          queue: "Grup",
          result: "Durum",
          missed: "Kaçan",
          sip_hangup_disposition: "Kapatan",
          answer_stamp: "Cevap verme tarihi",
          end_stamp: "Görüşme sonu"
        }
      }
    };
  },
  created() {
    this.getCalls();
    setInterval(() => {
      this.getCalls();
    }, 60000);
  },
  methods: {
    openPopup(tr) {
      this.popupActivo.show = true;
      this.popupActivo.detail = tr;
      console.log(tr);
    },
    getCalls: async function() {
      this.calls = await repository
        .getAll("General/GetLast100Calls")
        .then(r => r.list);
    }
  }
};
</script>
